import { useToastNotification } from "lib/hooks";
import { validateClient } from "lib/clients";
import { AlertInfo } from "./alertInfo";
import { Link } from "@chakra-ui/react";
import { FC } from 'react';

export const VerifyEmailAlert: FC<{ content: string}> = ({ content }) => {
  const { errorToast, infoToast } = useToastNotification();

  const resendEmail = async (): Promise<void> => {
    try {
      await validateClient.validateEmail();
      infoToast({
        title: 'Email sent',
        description: 'Please check your inbox for the verification email'
      })
    } catch (err) {
      errorToast({
        title: 'Error',
        description: 'Unable to resend verification email',
      })
    }
  }

  return (
    <AlertInfo>
      <>{ content }&nbsp;<Link textDecoration={"underline"} onClick={resendEmail}>Resend verification email.</Link></>
    </AlertInfo>
  )
}
